export default __webpack_public_path__ + "static/media/dice2.caccd70c.png";